import React from 'react';

import { CtaButton, type CtaButtonProps } from 'components/global/CtaButton';
import { Product, type ProductProps } from './components/Product';

import {
  DesktopDisclaimer,
  InnerBox,
  LeftContent,
  MobileDisclaimer,
  ProductsContainer,
  ProductsPopContainer,
  Subtitle,
  Summary,
  Title,
  desktopCtaStyles,
  mobileCtaStyles,
} from './ProductsPop.style';

export interface ProductsPopProps {
  title?: string;
  subtitle?: string;
  products: ProductProps[];
  ctaButton?: CtaButtonProps;
  disclaimerText?: string;
}

const moduleName = 'productsPop';

export const ProductsPop = ({
  title,
  subtitle,
  products,
  ctaButton,
  disclaimerText,
}: ProductsPopProps) => {
  return (
    <ProductsPopContainer data-module={moduleName}>
      <InnerBox>
        <LeftContent>
          <Summary>
            <Title>{title}</Title>
            <Subtitle>{subtitle}</Subtitle>
          </Summary>
          {ctaButton && <CtaButton {...ctaButton} css={desktopCtaStyles} />}
          {disclaimerText && (
            <DesktopDisclaimer
              dangerouslySetInnerHTML={{
                __html: disclaimerText,
              }}
            />
          )}
        </LeftContent>
        <ProductsContainer>
          {products.map((product, index) => (
            <Product key={index} size={products.length} {...product} />
          ))}
        </ProductsContainer>
        {ctaButton && <CtaButton {...ctaButton} css={mobileCtaStyles} />}
        {disclaimerText && (
          <MobileDisclaimer
            dangerouslySetInnerHTML={{
              __html: disclaimerText,
            }}
          />
        )}
      </InnerBox>
    </ProductsPopContainer>
  );
};
